/**
 * Copied from Core. Extract a pretty error message from the server error response.
 */
export function parseServerError(error?: Record<string, any>) {
  let msg = 'Sorry an error has occurred. Please try again later.';

  if (!error) {
    return msg;
  }

  const notification = error.response?.data || error.data || error;

  if (notification.code === 'VALIDATION_ERROR') {
    notification.errors.forEach((validationError: any) => {
      let userErrorMsg = validationError.message || '';
      if (validationError.param) {
        if (validationError.param === 'siteIds' && validationError.msg === 'is invalid (notEmpty)') {
          userErrorMsg = 'You have no sites.';
        } else {
          userErrorMsg = `${validationError.param || ''} ${validationError.msg || ''}`.trim();
        }
      }
      return userErrorMsg;
    });

    return 'A validation error has occurred.';
  } else {
    switch (notification.code) {
      case 'NOT_AUTHENTICATED':
        msg = notification.message;
        break;
      case 'INCORRECT_LOGIN_DETAILS':
        msg = 'The login details are incorrect. Please try again.';
        break;
      case 'INCORRECT_OLD_PASSWORD':
        msg = 'The old password you entered is incorrect';
        break;
      case 'USER_ALREADY_EXISTS':
        msg = !notification.customMsg ? 'There is already a user with that email' : notification.customMsg;
        break;
      case 'PASS_ALREADY_EXISTS':
        msg = !notification.customMsg ? 'Guest already signed in' : notification.customMsg;
        break;
      case 'VERIFY_TOKEN_INVALID':
        msg = 'The Verification pin you entered is incorrect. Please try again.';
        break;
      case 'FORBIDDEN':
        msg = 'This action is not allowed, please contact administrator.';
        break;
      case 'INTEGRATION_OAUTH_FAILED_ERROR':
        msg = 'Integration Authentication failed, please contact administrator';
        break;
      case 'INTERNAL_SERVER_ERROR':
        msg = 'Server Error occurred';
        break;
      case 'PERMISSION_ALREADY_EXISTS':
        msg = 'This team member already has these permissions';
        break;
      case 'SITE_NAME_NOT_IDENTICAL':
        msg = 'Site names created under the same team must not be identical.';
        break;
      case 'SITE_CHECKIN_DISABLED':
        msg = 'Check-ins at this site are currently deactivated. Contact Sine Support for assistance.';
        break;
      case 'INVALID_PASS_STATUS':
        msg = `${error.customMsg} - this pass has already been actioned`;
        break;
      case 'USER_VERIFICATION_REQUIRED':
        msg = 'Your account is not verified. Please verify and try again.';
        break;
      case 'CONFLICT':
        msg = notification.message || 'This resource already exists';
        break;
      default: {
        if (notification.message && notification.message !== '') {
          msg = notification.message;
        }

        msg = notification.customMsg ? notification.customMsg : error.customMsg ? error.customMsg : msg;
      }
    }
    return msg;
  }
}
